export const FORM_NAME = 'ScheduledRentForm';
export const INPUT_HEIGHT = 40;
